/**
 * Created by lapcho on 06.02.17..
 */
export default class {
    constructor($http, toastr, $q, $state, Config) {
        'ngInject';
        this.$http = $http;
        this.toastr = toastr;
        this.$q = $q;
        this.Config = Config;
        this.$state = $state;
    }

    $onInit() {
        this.products = null;
        this.collection = null;
    }

    initProducts(products) {
        this.products = products;
        this.$state.go("user.productCollection");
    }

    getCollection(id) {
        this.dropDownSelected = true;

        return this.$http({
            url: this.Config.API + '/contentbank-collection/' + id,
            method: 'GET'

        }).then((response) => {

            //need to add push products from service to array
            this.collection = response.data;

        }).catch((status) => {

            this.toastr.error('Server Error, Try again');

        })

    };

    getExistingCollections(drafts) {

        return this.$http({
            url: this.Config.API + '/contentbank-collection/',
            method: 'GET',
            headers: {
                'drafts': drafts
            }

        }).then((response) => {

            this.existingCollections = response.data;

        }).catch((status) => {

            this.toastr.error('Server Error, Try again');

        });
    }

    generatePdfDownloadLinkForCollections(collections) {
        var queryString = '?';
        angular.forEach(collections, function(value, key) {
            var tmp = 'collection[]=' + value;
            if (collections.length - 1 != key) {
                tmp += '&';
            }
            queryString += tmp;
        });
        return this.Config.API + '/contentbank-collection/pdf/download' + queryString;
    }

    deleteCollections(id_array) {
        console.log('col service delete');
        var promises = [];
        angular.forEach(id_array, (id) => {
            promises.push(this.$http({
                url: this.Config.API + '/contentbank-collection/' + id,
                method: 'DELETE',
            }).then((response) => {}).catch((status) => {
                this.toastr.error('Server Error while deleting collection, Try again');
            }));
        });
        return this.$q.all(promises);
    }

    updateReadAt(collectionId) {

        let deferred = this.$q.defer();

        this.getCollection(collectionId).then(() => {
            var data = {
                "read_at": Math.round((new Date()).getTime() / 1000)
            };
            this.$http({
                url: this.Config.API + '/contentbank-collection/' + this.collection.id,
                method: 'PATCH',
                data: data
            }).then((response) => {
                deferred.resolve(response.data);
                //collection updated
            });
        });

        return deferred.promise;

    }

    markUnread(id_array) {
        var promises = [];
        angular.forEach(id_array, (id) => {

            promises.push(
                this.getCollection(id).then(() => {
                    // console.log(this.collection);
                    var data = {
                        "read_at": 0
                    };
                    return this.$http({
                        url: this.Config.API + '/contentbank-collection/' + this.collection.id,
                        method: 'PATCH',
                        data: data
                    });
                })
            );

        });
        return this.$q.all(promises);
    }

    markAsMine(id_array) {
        var promises = [];
        angular.forEach(id_array, (id) => {
            promises.push(
                this.getCollection(id).then(() => {
                    var data = {
                        "owner_id": localStorage.getItem('userId')
                    };
                    this.$http({
                        url: this.Config.API + '/contentbank-collection/' + this.collection.id,
                        method: 'PATCH',
                        data: data
                    }).then((response) => {
                        //collection updated
                    })
                })
            )
        })
        return this.$q.all(promises);
    }

    archive(id) {
        let deferred = this.$q.defer();

        this.$http({
            url: this.Config.API + '/contentbank-collection/' + this.collection.id,
            method: 'PATCH',
            data: {
                archived: true,
                owner_id: null
            }
        }).then((response) => {
            deferred.resolve(response.data);
            //collection updated
        });

        return deferred.promise;

    }

    updateStarred(collectionId, starred) {

        let deferred = this.$q.defer();

        this.getCollection(collectionId).then(() => {
            var data = {
                'starred': starred
            };
            this.$http({
                url: this.Config.API + '/contentbank-collection/' + collectionId,
                method: 'PATCH',
                data: data
            }).then((response) => {
                deferred.resolve(response.data);
                //collection updated
            });
        });

        return deferred.promise;

    }

}


// WEBPACK FOOTER //
// ./client/app/services/collection.js